import styled, { keyframes } from "styled-components";
import { colorWhite } from "@nib-components/theme";
import { mixins } from "@nib-group/chatbot-shared/styles";
// ----------------------------------------
// Local variables
const LIVE_INDICATOR_DIAMETER = "10px";
// ----------------------------------------
// Animation
/**
 * Expand and fade-out animation for "live" status blinker.
 * Note: `translateY` maintained here for centre alignment
 */
const expandFade = keyframes`
  0% {
    transform: translateY(-50%) scale(1);
		opacity: 0.75;
  }

  100% {
		transform: translateY(-50%) scale(2);
		opacity: 0;
  }
`;
// ----------------------------------------
// Exports
export const LiveIndicator = styled.span`
  position: relative;
  height: 100%;
  width: ${LIVE_INDICATOR_DIAMETER};
  margin-right: 10px;

  &::before,
  &::after {
    ${mixins.pseudo}
    ${mixins.circle(LIVE_INDICATOR_DIAMETER)}
		${mixins.alignVertical}
		background-color: ${colorWhite};
  }

  // Note this animation purposefully doesn't have a
  // "prefers-reduced-motion" flag, as it's very low-impact
  &::before {
    animation: ${expandFade} 2s infinite ease-in-out;
    will-change: opacity, transform;
  }
`;